import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Authorization } from "../../../Context/Authorization";
import Preloader from "../../../shared/PreLoaders";

const ShgDetails = () => {
  const { shgId } = useParams();
  const [shg, setVfc] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const Api = process.env.REACT_APP_API;
  const LOCAL_KEY = `shgSummarryData${shgId}`;

  const saveToLocalCache = (vfcData) => {
    localStorage.setItem(
      LOCAL_KEY,
      JSON.stringify({ vfcList: vfcData, timestamp: new Date().toISOString() })
    );
  };

  const loadFromLocalCache = () => {
    const cached = localStorage.getItem(LOCAL_KEY);
    return cached ? JSON.parse(cached) : null;
  };

  const fetchVFCDetails = async () => {
    const config = Authorization();
    try {
      const res = await axios.get(`${Api}/api/shgs/${shgId}`, config);
      setVfc(res.data.shg);
      saveToLocalCache(res.data.shg);
    } catch (error) {
      console.error("Failed to fetch VFC details:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    const cached = loadFromLocalCache();
    if (cached && cached.vfcList) {
      setVfc(cached.vfcList);
      setLoading(false);
    } else {
      fetchVFCDetails();
    }
  }, [shgId]);

  if (loading) return <Preloader loading={true} />;
  if (!shg)
    return <p className="text-danger m-5">SHG not found or access denied.</p>;

  const formatDate = (date) => {
    if (!date) return "N/A";
    return new Date(date).toLocaleDateString("en-IN");
  };

  const details = [
    { label: "Circle", value: shg.circleName },
    { label: "Division", value: shg.divisionName },
    { label: "Range", value: shg.rangeName },
    { label: "VFC Name", value: shg.vfcId.vfcName },
    { label: "VFC Code", value: shg.vfcId.vfcCode },
    { label: "Location", value: shg.location },
    { label: "Village", value: shg.village },
    { label: "Thaluk", value: shg.thaluk },
    { label: "Panchayath", value: shg.panchayath },
    { label: "PIN Code", value: shg.pinCode },
    { label: "Est. Date", value: formatDate(shg.dateOfEstablishment) },
    { label: "Bank Name", value: shg.bankName },
    { label: "Branch", value: shg.branch },
    { label: "IFSC Code", value: shg.ifscCode },
    { label: "Account Number", value: shg.accountNumber },
    { label: "Total Members", value: shg.totalMembers },
    { label: "Male", value: shg.maleCount },
    { label: "Female", value: shg.femaleCount },
    { label: "Third Gender", value: shg.otherCount },
  ];

  return (
    <div>
      <div className="page-header">
        <div className="d-flex justify-content-between align-items-center mb-3 px-2">
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() => {
              localStorage.removeItem(LOCAL_KEY);
              setLoading(true);
              fetchVFCDetails();
            }}
          >
            🔄 Refresh Now
          </button>
        </div>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li
              className="breadcrumb-item"
              style={{
                color: "blue",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => navigate(-1)}
            >
              ← Back
            </li>
            <li
              className="breadcrumb-item active"
              style={{
                color: "red",
                cursor: "pointer",
              }}
              onClick={() => navigate("/dashboard")}
            >
              🏠 Home
            </li>
            <li
              className="breadcrumb-item"
              style={{
                color: "blue",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => navigate(+1)}
            >
              → Previous
            </li>
          </ol>
        </nav>
      </div>

      <div className="card bg-gradient-SuccessLightGradient card-img-holder text-white mb-4">
        <div className="card-body">
          <img
            src={require("../../../../assets/images/dashboard/circle.png")}
            className="card-img-absolute"
            alt="circle"
          />
          <h4 className="font-weight-bold mb-3">SHG - {shg.name}</h4>
          <h4 className="font-weight-normal mb-3">
            Total Members - {shg.totalMembers}
          </h4>
        </div>
      </div>
      <div className="col-lg-12 stretch-card">
        <div className="card">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-bordered">
                <tbody>
                  {details.map((item, idx) => (
                    <tr key={idx} className="table-success">
                      <td style={{ fontWeight: "bold", width: "30%" }}>
                        {item.label}
                      </td>

                      <td>{item.value ?? "N/A"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShgDetails;
